import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import QuestionHeader from "./QuestionHeader.vue";
let QuestionContent = class QuestionContent extends Vue {
    formatAnswer(options, type) {
        let answer = '';
        if (2 === type) {
            // answer = ve.a.filter(question.correct_answer);
            if (options.length > 0) {
                answer = options[0].content;
            }
        }
        else if (4 === type) {
            const length = options.length;
            for (let i = 0; i < length; i++) {
                var _answer = options[i].content.split('；');
                if (_answer.length > 1) {
                    answer += `“${_answer.join('” 或 “')}”；`;
                }
                else {
                    answer += `${0 !== i && i !== length ? '；' : ''}${_answer[0]}`;
                }
            }
        }
        return answer;
    }
};
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionContent.prototype, "question", void 0);
tslib_1.__decorate([
    Prop({ type: Number })
], QuestionContent.prototype, "index", void 0);
QuestionContent = tslib_1.__decorate([
    Component({
        name: 'QuestionContent',
        components: {
            QuestionHeader
        }
    })
], QuestionContent);
export default QuestionContent;
